import ImageWithBasePath from './ImageWithBasePath'

export const OpenPlayStore = ({ translation, isHeaderPresent = true }) => {
  return (
    <div className="my-[24px] space-y-[8px] ">
      {isHeaderPresent && (
        <div className="font-roboto text-md font-normal leading-[18.75px] text-[#333436]">
          {translation?.downLoadApp}?
        </div>
      )}
      <div
        className="flex w-fit cursor-pointer items-center space-x-[10.93px] rounded-xs border-[1px] border-solid border-[#A6A6A6] bg-[#000000] pl-[13px] pt-[5px] pb-[7.7px] pr-[12.24px]"
        onClick={() =>
          window.open('https://play.google.com/store/apps/details?id=get.lokal.localnews')
        }
      >
        <ImageWithBasePath src="playStore" width={30.79} height={33.44} alt="play store" />
        <div className="space-y-[2.16px]">
          <div className="text-[11px] font-medium leading-[14.61px] text-white">
            {translation?.getTheApp}
          </div>
          <ImageWithBasePath src="Google Play" width={113.04} height={22.14} alt="Google Play" />
        </div>
      </div>
    </div>
  )
}
